















import { Prop, Component, Vue } from "vue-property-decorator";
import TaskType from "@/entities/task-type";
import Action from "@/models/action";
import VToolbar from "../components/VToolbar.vue";
import VDraggableList from "../components/VDraggableList.vue";
import VDraggableListItem from "../components/VDraggableListItem.vue";

@Component({
  components: {
    VToolbar,
    VDraggableList,
    VDraggableListItem
  }
})
export default class TaskTypeList extends Vue {
  @Prop({ default: () => [] }) actions!: Action[];
  @Prop({ default: () => [] }) tasktypes!: TaskType[];

  sort(tasktypes: TaskType[]) {
    this.$emit("sort", tasktypes);
  }
}
